import React from 'react';
import * as S from './NavigationItem.style';

export type SidebarNavItemsProps = {
  active: boolean;
  name: string;
  goTo: any;
  link: string;
  id?: string;
  Icon: any;
  expanded?: boolean;
};

export const SidebarNavItem = ({
  id,
  active,
  name,
  goTo,
  link,
  Icon,
  expanded = false,
}: SidebarNavItemsProps): JSX.Element => {
  return (
    <S.NavItem id={id}>
      <S.NavLink href={link} data-active={active} onClick={goTo}>
        <S.NavIcon>{React.cloneElement(<Icon />, { active }, null)}</S.NavIcon>
        <S.NavText expanded={expanded}>{name}</S.NavText>
      </S.NavLink>
    </S.NavItem>
  );
};
